/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest
 */
export interface CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest {
    /**
     * The name of the freelancers workforce misclassification threshold.
     * @type {string}
     * @memberof CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest
     */
    name: string;
    /**
     * The number of days before a job is considered overdue.
     * @type {number}
     * @memberof CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest
     */
    daysThreshold: number;
    /**
     * The ISO 3166-1 alpha-2 country codes that the misclassification threshold applies to.
     * @type {Set<string>}
     * @memberof CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest
     */
    countryCodes?: Set<string>;
    /**
     * Email addresses of the recipients to notify when the threshold is triggered.
     * @type {Set<string>}
     * @memberof CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest
     */
    recipientEmails?: Set<string>;
}

/**
 * Check if a given object implements the CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest interface.
 */
export function instanceOfCreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest(value: object): value is CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('daysThreshold' in value) || value['daysThreshold'] === undefined) return false;
    return true;
}

export function CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequestFromJSON(json: any): CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest {
    return CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequestFromJSONTyped(json, false);
}

export function CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'daysThreshold': json['daysThreshold'],
        'countryCodes': json['countryCodes'] == null ? undefined : json['countryCodes'],
        'recipientEmails': json['recipientEmails'] == null ? undefined : json['recipientEmails'],
    };
}

export function CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequestToJSON(value?: CreateOrUpdateFreelancersWorkforceMisclassificationThresholdRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'daysThreshold': value['daysThreshold'],
        'countryCodes': value['countryCodes'] == null ? undefined : Array.from(value['countryCodes'] as Set<any>),
        'recipientEmails': value['recipientEmails'] == null ? undefined : Array.from(value['recipientEmails'] as Set<any>),
    };
}

